<div class="flex items-center gap-3 min-w-0">
    <!-- The API never delivers a thumbnail (yet) — an unguarded access crashed the row's
         view creation and left every select row visually empty -->
    @if (entity().thumbnail) {
        <immo-image
            class="h-10! w-10! shrink-0 rounded-sm overflow-hidden"
            fit="cover"
            resolution="none"
            [src]="entity().thumbnail.url"
            [alt]="entity().name" />
    }
    <div class="flex flex-col min-w-0">
        <span class="font-medium truncate">
            {{ entity().name }}
        </span>
        <span class="text-sm text-muted-foreground truncate">
            <!-- street is the full addressLine1 incl. house number — houseNumber never comes from the api -->
            {{ entity().address.street }} · {{ entity().address.zipCode }} {{ entity().address.city }}
        </span>
    </div>
</div>